export interface DocumentThemePurchaseOrderHeaderOptions {

    /* Show Job Number - displays the Job Number from the parent job */
    showJobNumber: boolean;

    /* Show Comments - displays the notes  */
    showComments: boolean;

    /* Allows overwriting the name quote useful for creating Estimates etc */
    entityName: string;

}


export interface DocumentThemePurchaseOrderItemOptions {

    /* 
    Show Quantity - if false, no quantity will be displayed
     */
    showQuantity: boolean;

    /* 
    Show Unit Price - if false, no unit price will be displayed 
    */
    showUnitPrice: boolean;

    /* 
    Show Tax - if false, no adjustments will be displayed.the adjustment will either be the percentage or dollar value
    */
    showTax: boolean;

    /*
    Show Total - if false, no line total will be displayed.If true, display the tax amount of the line and the total ex tax
    */
    showTotals: boolean;

}

export interface DocumentThemePurchaseOrderOptions {
    header: DocumentThemePurchaseOrderHeaderOptions;
    items: DocumentThemePurchaseOrderItemOptions
}

export const defaultPurchaseOrderOptions: DocumentThemePurchaseOrderOptions = {
    header: {
        entityName: 'Purchase Order',
        showJobNumber: true,
        showComments: true,
    },
    items: {
        showQuantity: true,
        showUnitPrice: true,
        showTax: true,
        showTotals: true
    }
};


